import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useFormik } from "formik";
import * as Yup from "yup";
import { patchRequest, postRequest, putRequest } from "../services/apiMethods";
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";

export default function SetPassword() {
  const Navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const userId = sessionStorage.getItem("userId")
  const [localLoading, setLocalLoading] = useState(false);

  const { mutate, isLoading } = useMutation({
    mutationFn: (data) => patchRequest(`user/setPassword/${userId}`, data),
    onMutate: () => setLocalLoading(true),
    onSuccess: (data) => {
      toast.success(`success`, {
        iconTheme: {
          primary: '#337FE0',
          secondary: '#FFFAEE',
        },
      });
      Navigate(`/summary`);
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
    onSettled: () => setLocalLoading(false),
  });

  const formik = useFormik({
    initialValues: {   
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({

      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm Password is required"),
    }),
    validateOnBlur: false,
    // validateOnChange: false,
    onSubmit: () => { }, // prevent automatic submission
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Mark all fields as touched
    formik.setTouched({
      password: true,
      confirmPassword: true,
    });

    const errors = await formik.validateForm();

    if (Object.keys(errors).length === 0) {
      const values = formik.values;


      const payload = {
        // subscriptionId: subscriptionId,
        // preferedStoreId: storeid,
        // role: "user",
        // firstName: userData?.firstName,
        // lastName: userData?.surname,
        password: values?.confirmPassword,
        // address: {
        //   postCode: userData?.postcode,
        // },
        // userLocation: {
        //   type: "Point",
        //   coordinates: [
        //     mapCenter?.lng,
        //     mapCenter?.lat
        //   ],
        // },
      };

      mutate(payload);
    }
  };

  return (
    <section className="commn-bg-set">
      <div className="card-center-set">
        <div className="commn-card-theme">
          <img
            className="side-logo-set"
            src={require("../Assets/images/logo-main.png")}
            alt="Logo"
          />
          <h2>Register</h2>
          <p>Become a Quaffee Club member today</p>

          <div className="register-data">
            <Form onSubmit={handleSubmit}>
 

              <Form.Group className="mb-3" controlId="password">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  placeholder="Enter password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  autoComplete="new-password"
                  // readOnly
                  // onFocus={(e) => e.target.removeAttribute('readOnly')}
                />
                {formik.errors.password && formik.touched.password && (
                  <div style={{ color: "#dc3545", fontSize: "14px", marginTop: "4px" }}>
                    {formik.errors.password}
                  </div>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="confirmPassword">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  type="password"
                  name="confirmPassword"
                  placeholder="Re-enter password"
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  autoComplete="new-password"
                  // readOnly
                  // onFocus={(e) => e.target.removeAttribute('readOnly')}
                />
                {formik.errors.confirmPassword && formik.touched.confirmPassword && (
                  <div style={{ color: "#dc3545", fontSize: "14px", marginTop: "4px" }}>
                    {formik.errors.confirmPassword}
                  </div>
                )}
              </Form.Group>

              <Button variant="primary" type="submit" disabled={isLoading || localLoading}>
                {localLoading ? "Please wait..." : "Next"}
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </section>
  );
}
